import { copyToClipboard } from '@/utils/clipboard';
import { TimelineItem } from '@yaradigitallabs/ahua-react';

import { Colors } from '../../../../../public/GlobalTokens';
import { showCopyToast } from '../../utils/helpers';
import { GuidelineDialog } from './GuidelineDialog';

const softTagNameExample = `SoftTagManager`;

const handleCopy = async (
  e: React.MouseEvent<HTMLButtonElement, MouseEvent>
) => {
  try {
    const success = await copyToClipboard(softTagNameExample);
    const container = e.currentTarget.parentElement as HTMLDivElement;
    if (container) {
      if (success) {
        showCopyToast(container, 'Copied', false);
      } else {
        showCopyToast(container, 'Copy failed', true);
        console.warn('Failed to copy to clipboard');
      }
    }
  } catch (error) {
    console.error('Copy operation failed:', error);
    const container = e.currentTarget.parentElement as HTMLDivElement;
    if (container) {
      showCopyToast(container, 'Copy error', true);
    }
  }
};

// CreateSoftTagNamingGuideline: Shows guidelines for creating soft tag names
export const CreateSoftTagNamingGuideline = () => (
  <div className="z-10">
    <GuidelineDialog
      title="Soft Tag Naming Convention Guideline"
      icon="Info"
      iconSize="s"
      triggerTitle="Create SoftTag Naming Guideline"
      content={
        <div>
          Soft tag name should follow the <b>ISA-95</b> naming convention using{' '}
          <b>Pascal Case</b>
          <br />
          Soft Tag Name Example:
          <div className="flex items-center">
            <span
              className="font-mono"
              style={{ backgroundColor: Colors.colorType.grayscale.lighter }}
            >
              {softTagNameExample}
            </span>
            <TimelineItem>
              <TimelineItem.IconButton
                colorConcept="brand"
                icon="Copy"
                size="xs"
                title="Copy Soft Tag Name Example"
                type="filled"
                onClick={handleCopy}
              />
            </TimelineItem>
          </div>
        </div>
      }
      helperText={
        <>
          Please adhere to soft tag naming convention{' '}
          <a
            href="https://yara-global.atlassian.net/wiki/x/AgHLRw"
            target="_blank"
            rel="noopener noreferrer"
            className="underline"
            style={{ color: Colors.ahua.blue.scale50 }}
          >
            guidelines
          </a>
          .
        </>
      }
    />
  </div>
);
